/**
 * @notes: Authentication Action types
 */

export const UPDATE_SMALA_TOKEN = "UPDATE_SMALA_TOKEN";

// sign up action types
export const SIGNUP_REQUEST_BEGIN = "SIGNUP_REQUEST_BEGIN";
export const SIGNUP_REQUEST_SUCCESS = "SIGNUP_REQUEST_SUCCESS";
export const SIGNUP_REQUEST_FAILURE = "SIGNUP_REQUEST_FAILURE";

// login action types
export const LOGIN_REQUEST_BEGIN = "LOGIN_REQUEST_BEGIN";
export const LOGIN_REQUEST_SUCCESS = "LOGIN_REQUEST_SUCCESS";
export const LOGIN_REQUEST_FAILURE = "LOGIN_REQUEST_FAILURE";
export const STOP_WAITING = "STOP_WAITING";

// logout action types
export const LOGOUT_REQUEST_BEGIN = "LOGOUT_REQUEST_BEGIN";
export const LOGOUT_REQUEST_SUCCESS = "LOGOUT_REQUEST_SUCCESS";
export const LOGOUT_REQUEST_FAILURE = "LOGOUT_REQUEST_FAILURE";

// recover password action types
// eslint-disable-next-line sonarjs/no-hardcoded-passwords
export const RECOVER_PASSWORD_BEGIN = "RECOVER_PASSWORD_BEGIN";
// eslint-disable-next-line sonarjs/no-hardcoded-passwords
export const RECOVER_PASSWORD_SUCCESS = "RECOVER_PASSWORD_SUCCESS";
// eslint-disable-next-line sonarjs/no-hardcoded-passwords
export const RECOVER_PASSWORD_FAILURE = "RECOVER_PASSWORD_FAILURE";

// change password action types
// eslint-disable-next-line sonarjs/no-hardcoded-passwords
export const CHANGE_PASSWORD_BEGIN = "CHANGE_PASSWORD_BEGIN";
// eslint-disable-next-line sonarjs/no-hardcoded-passwords
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
// eslint-disable-next-line sonarjs/no-hardcoded-passwords
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

export const CHANGE_LANG_SUCCES = "CHANGE_LANG_SUCCESS";
export const CHANGE_PROFILE_PICTURE_SUCCESS = "CHANGE_PROFILE_PICTURE_SUCCESS";

export const SET_ACTIONS_AVAILABLE_SUCCESS = "SET_ACTIONS_AVAILABLE_SUCCESS";
export const SET_ACCESS_RIGHT_PROFILE_SUCCESS =
  "SET_ACCESS_RIGHT_PROFILE_SUCCESS";

export const GET_LAST_VERSION_SUCCESS = "GET_LAST_VERSION_SUCCESS";

export const DISPLAY_SWITCH_TO_WEB_MESSAGE = "DISPLAY_SWITCH_TO_WEB_MESSAGE";

export const CHANGE_DISPLAY_LANG_SUCCESS = "CHANGE_DISPLAY_LANG_SUCCESS";
